<template>
<router-link class="featured-item" :to="to">
   
  <div class="container">
    <div  v-if="title" class="title-container" :class="{'fixed-width':text}">
      <div class="title">{{title}}</div>
    </div> 
    <div v-if="text" class="text">{{text}}</div>
    
   
  </div>
  <div class="subtitle" v-if="subtitle">{{computeExcerpt}}</div>
   
</router-link>
</template>

<script>
import { helper } from '../../services/Helper.js';
import i18n from "../../language.js";


export default {
  name: 'featured-album-item',
  props:{
    to:{default:"/"},
    title:{default:undefined},
    subtitle:{default:undefined},
    text:{default:undefined},
  },
  data:function(){
    return {
    }
  },
  components:{
  },
  methods:{
  },
  computed:{
    
    computeExcerpt(){
        var read_more=" ["+i18n.t('language.lees_meer')+"]"
        return helper.getExcerpt(this.subtitle,read_more);
      },
  },
  mounted:function(){
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.featured-item{
  text-decoration: none;
  cursor:pointer;
  color:inherit;
  display:block;
  position:relative;
  
  padding: 10px 0;
}
.container{
  width:100%;
  display:flex;
  

}
.fixed-width{
   min-width: 120px;
   margin-right:5px;
}

.title-container{
  display:flex;
}
.title{
  font-weight:bold;
}

.subtitle{
  padding-top: 5px;
    font-size: .8em;
    color: #646464;
}
.text{
  flex:1;
}


</style>

